var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "manual-bet",
      class: _vm.styling ? "manual-bet_" + _vm.styling : "",
    },
    [
      _c("div", { staticClass: "manual-bet__form bet-form" }, [
        !_vm.isStreamerMode
          ? _c(
              "label",
              { staticClass: "bet-form__label", attrs: { for: "bet-amount" } },
              [_vm._v(" 输入金额 ")]
            )
          : _c(
              "label",
              { staticClass: "bet-form__label", attrs: { for: "bet-amount" } },
              [_vm._v(" 输入积分 ")]
            ),
        _c("div", { staticClass: "bet-form__wrapper" }, [
          _c("span", {
            staticClass: "bet-form__currency",
            class: "currency_" + _vm.fastAmountCurrency,
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.betAmount,
                expression: "betAmount",
                modifiers: { number: true },
              },
            ],
            staticClass: "bet-form__input",
            attrs: {
              id: "bet-amount",
              type: "number",
              autocomplete: "off",
              placeholder: "0",
              disabled: _vm.disabled,
            },
            domProps: { value: _vm.betAmount },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.betAmount = _vm._n($event.target.value)
                },
                _vm.onBetAmountChanged,
              ],
              blur: [
                _vm.onBetAmountBlur,
                function ($event) {
                  return _vm.$forceUpdate()
                },
              ],
            },
          }),
          _c(
            "button",
            {
              staticClass: "bet-form__action btn",
              attrs: {
                type: "button",
                "aria-label": "clear amount",
                disabled: !_vm.canClearAmount || _vm.disabled,
              },
              on: { click: _vm.clearAmount },
            },
            [_c("span", { staticClass: "icon icon_broom" })]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "manual-bet__actions" },
        [
          _vm._l(_vm.fastAmounts, function (fastAmount) {
            return _c(
              "button",
              {
                key: fastAmount,
                staticClass: "manual-bet__action btn",
                class: { "is-active": fastAmount === _vm.betAmount },
                attrs: { type: "button", disabled: _vm.disabled },
                on: {
                  click: function ($event) {
                    return _vm.setFastAmount(fastAmount)
                  },
                },
              },
              [
                _c("div", { staticClass: "btn__text currency_USD" }, [
                  _vm._v(" " + _vm._s(fastAmount) + " "),
                ]),
              ]
            )
          }),
          _c(
            "button",
            {
              staticClass: "manual-bet__action btn",
              class: { "is-active": _vm.isMaxAmount },
              attrs: { type: "button", disabled: _vm.disabled },
              on: { click: _vm.setMaxAmount },
            },
            [_vm._v(" MAX ")]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }